export default {
	title: "Meu Perfil",
	tabs: {
		personal: "Dados Pessoais",
		religious: "Religioso",
		security: "Segurança",
	},
	fields: {
		displayName: "Nome de exibição",
		email: "E-mail",
		phone: "Telefone",
		whatsappOptIn: "Receber alertas do ORI por WhatsApp",
		whatsappOptInHint: "Avisos de gestão do templo (pagamentos recebidos, despesas, fechamento) enviados pelo número oficial do ORI para o telefone acima",
		religiousName: "Nome religioso",
		title: "Título",
		ritualFunction: "Função ritual",
		role: "Papel no templo",
		currentPassword: "Senha atual",
		newPassword: "Nova senha",
		confirmPassword: "Confirmar nova senha",
	},
	photo: {
		change: "Alterar foto",
		remove: "Remover foto",
	},
	messages: {
		saved: "Perfil atualizado com sucesso",
		photoUploaded: "Foto atualizada com sucesso",
		photoRemoved: "Foto removida com sucesso",
		errorSaving: "Erro ao salvar perfil",
		errorPhoto: "Erro ao atualizar foto",
		changePassword: "Alterar Senha",
		passwordChanged: "Senha alterada com sucesso",
		passwordsDoNotMatch: "As senhas não conferem",
		wrongCurrentPassword: "Senha atual incorreta",
	},
	stats: {
		temple: "Templo",
	},
};
